import { useDispatch, useSelector } from "react-redux";
import { TbReload } from "react-icons/tb";
import styles from "../../../styles/pages/Auth/login/RecaptchaModal.module.css";
import { Input, Skeleton, Spin } from "antd";
import React, { useEffect, useRef } from "react";
import { generateTextCaptcha } from "../../../redux/main/action/main";
import { IoMdRefresh } from "react-icons/io";
import { IoCloseCircle } from "react-icons/io5";

function TextCaptcha({
  captchaValue = "",
  setCaptchaValue,
  handleEnterKeyDown,
  loading: submitLoading,
}) {
  const { captchaData, captchaStatus, captchaError } = useSelector(
    (state) => state?.main,
  );

  const inputRef = useRef(null);

  const dispatch = useDispatch();

  const loading = captchaStatus === "loading";

  const refreshRecaptcha = () => {
    if (submitLoading) return;

    dispatch(generateTextCaptcha());
  };

  const handleInputChange = (e) => {
    setCaptchaValue(e.target.value?.trimStart());
  };

  useEffect(() => {
    if (
      captchaStatus !== "loading" &&
      captchaStatus !== "error" &&
      !captchaData?.captcha_id
    ) {
      dispatch(generateTextCaptcha());
    }
  }, [captchaData?.captcha_id, captchaStatus, dispatch]);

  useEffect(() => {
    if (inputRef.current && captchaStatus === "ready") {
      inputRef?.current?.focus();
    }
  }, [inputRef, captchaStatus]);

  return (
    <>
      {captchaStatus === "error" && (
        <div style={{ textAlign: "center" }}>
          <h4>Something went wrong!</h4>
          <TbReload
            size={24}
            onClick={refreshRecaptcha}
            style={{ cursor: "pointer" }}
          />
        </div>
      )}

      <div className={styles.form}>
        {captchaStatus === "loading" && (
          <Skeleton
            active
            paragraph={{ rows: 0 }}
            rootClassName={styles.loader}
          />
        )}
        {captchaStatus === "ready" && captchaData?.captcha_id && (
          <h4>{captchaData?.question}</h4>
        )}

        {/*<h4>{recaptchaData.question}</h4>*/}
        <div className={styles.inputContainer}>
          <Input
            placeholder="Enter your answer"
            value={captchaValue}
            onChange={handleInputChange}
            // onBlur={handleInputBlur}
            disabled={loading || submitLoading}
            onKeyDown={handleEnterKeyDown}
            name="text_captcha_id"
            ref={inputRef}
            // ref={inputRef}
          />
          <IoCloseCircle
            className={styles.resetIcon}
            style={{ opacity: `${captchaValue ? 1 : 0.6}` }}
            onClick={() => setCaptchaValue("")}
          />
        </div>
        {captchaData?.captcha_id && (
          <div className={styles.refreshIcon} onClick={refreshRecaptcha}>
            <IoMdRefresh />
          </div>
        )}
      </div>
    </>
  );
}

export default TextCaptcha;
